import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

const disabledStyles = css`
  cursor: default;
  pointer-events: none;
  background: ${COLORS.borderColor};
`

export const ToggleSwitcherCircle = styled.div<{
  $isChecked: boolean
}>`
  width: 16px;
  aspect-ratio: 1/1;
  background: ${COLORS.white};
  border-radius: 100%;

  position: absolute;
  left: 2.5px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s linear;

  ${({ $isChecked }) =>
    $isChecked &&
    css`
      transform: translateY(-50%) translateX(100%);
    `}
`

export const ToggleSwitcherWrapper = styled.div<{
  $isDisabled: boolean
  $isChecked: boolean
}>`
  flex-shrink: 0;
  position: relative;
  width: 37px;
  height: 20px;
  display: inline-flex;
  align-items: center;

  background-color: ${({ $isChecked }) =>
    $isChecked ? COLORS.primaryDark : COLORS.secondary};
  border-radius: 20px;

  transition: background-color 0.3s linear;

  cursor: pointer;

  ${({ $isDisabled }) => $isDisabled && disabledStyles}
`
